import { PlanType } from 'design-system-components/MailTockPricingCard/types';
import { PlanCycleTypes } from 'services/pricing-api/types';

export interface IBillingPeriod {
  startDate: string;
  endDate: string;
}

export interface IScheduledChange {
  action: string;
  effectiveDate: string;
}

export interface ISubscription {
  id: string;
  billingServiceId: string;
  discount: IDiscount;
  price: number;
  currencyCode: string;
  currentBillingPeriod: IBillingPeriod;
  planType: PlanType;
  billingCycleType: PlanCycleTypes;
  status: SubscriptionStatus;
  scheduledChange: IScheduledChange;
  startDate: string;
  firstBillingDate: string;
  nextBillingDate: string;
}

export interface IDiscount {
  id: string;
  code: string;
  amount: number;
  startDate: string;
  endDate: string;
}
export interface OkResponse {
  message: 'Ok';
}
export interface IChangeUserSubscriptionRequest {
  planType: PlanType;
  billingCycleType: PlanCycleTypes;
}
export interface IUpdatePaymentMethodResponse {
  link: string;
}

export interface ICancelUseSubscriptionRequest {
  reason: string;
  message?: string;
}

export interface IUpdateFlagsBody {
  promoteSlack?: boolean;
  channelFallback?: boolean;
}

export enum SubscriptionStatus {
  TRIALING = 'TRIALING',
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  PAST_DUE = 'PAST_DUE',
  PAUSED = 'PAUSED',
  NONE = 'NONE',
}
